export default "__VITE_ASSET__dHB5skZb__"